module.exports = __webpack_public_path__ + "static/img/3.0d313e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/3.png
// module id = yFD8
// module chunks = 0